/**
 * Left & Right Intro Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initLeftRightIntro() {
        const blocks = document.querySelectorAll('.left-right-intro');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] left-right-intro block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initLeftRightIntro);
    } else {
        initLeftRightIntro();
    }
})();